import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import Theme from 'core/themes/model'
import generateTestId from 'utils/test-helpers'

interface Props {
  displayName: string
  diameter?: number
  fontSize?: number
  onClick?: any
  className?: string
}

const useStyles = makeStyles<Theme>((theme) => ({
  avatar: {
    borderRadius: '50%',
    border: `1px solid ${theme.components.iconButton.border}`,
    backgroundColor: theme.components.iconButton.background,
    color: theme.components.iconButton.color,
    transition: 'all .2s ease',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    overflow: 'hidden',
  },
  avatarClickable: {
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: theme.components.iconButton.activeBackground,
      borderColor: theme.components.iconButton.activeBorder,
      color: theme.components.iconButton.activeColor,
    },
  },
  avatarReadOnly: {
    cursor: 'not-allowed',
  },
}))

const Avatar = ({ displayName = '', diameter = 48, fontSize = 18, onClick, className }: Props) => {
  const readOnly = !onClick
  const classes = useStyles()

  return (
    <div
      data-testid={generateTestId('user', 'menu')}
      className={clsx(
        classes.avatar,
        readOnly ? classes.avatarReadOnly : classes.avatarClickable,
        className,
      )}
      style={{
        height: diameter,
        width: diameter,
        fontSize: fontSize,
        lineHeight: fontSize,
      }}
      onClick={onClick}
    >
      {displayName.charAt(0)}
    </div>
  )
}

export default Avatar
